export default __webpack_public_path__ + "static/media/2.c8941737.png";